<template>
  <v-container fluid class="pa-8">
    <v-row align="center" class="mb-8 px-2">
      <v-col>
        <div class="d-flex align-center mb-1">
          <v-chip x-small color="orange darken-4" dark class="font-weight-black mr-3">BORRADOR</v-chip>
          <span class="grey--text text-overline font-weight-black letter-spacing-1">Revisión Final</span>
        </div>
        <h1 class="white--text text-h4 font-weight-black">Confirmar Inventario</h1>
      </v-col>
      
      <v-col cols="auto">
        <v-btn
          color="white"
          class="black--text text-none font-weight-black rounded-xl px-8"
          elevation="0"
          height="48"
          @click="dialogConfirmacion = true"
        >
          <v-icon left>mdi-check-all</v-icon> FINALIZAR Y CERRAR
        </v-btn>
      </v-col>
    </v-row>

    <div class="report-content-wrapper rounded-xl border-subtle pa-6 bg-dark-refined">
      <SucursalInventarioResumen :inventarioUuid="$route.params.inventarioUuid" />
    </div>

    <v-dialog v-model="dialogConfirmacion" max-width="550" persistent overlay-color="black" overlay-opacity="0.9">
      <v-card class="bg-dark-dialog rounded-xl pa-4 border-subtle">
        <v-card-title class="d-flex justify-center pb-0">
          <v-icon :color="errorMessage ? 'red' : 'orange'" size="48">
            {{ errorMessage ? 'mdi-alert-circle' : 'mdi-alert-octagon' }}
          </v-icon>
        </v-card-title>
        
        <v-card-text class="text-center pt-4">
          <h2 class="white--text text-h5 font-weight-black mb-2">
            {{ errorMessage ? 'Error al procesar' : '¿Cerrar inventario?' }}
          </h2>
          
          <v-expand-transition>
            <div v-if="errorMessage" class="error-box pa-4 rounded-lg mb-4 text-left border-red">
              <div class="red--text text-caption font-weight-black mb-1">DETALLE CONTABLE:</div>
              <div class="white--text text-body-2">{{ errorMessage }}</div>
            </div>
          </v-expand-transition>

          <p class="grey--text text-body-2" v-if="!errorMessage">
            Esta acción es irreversible. El stock de la sucursal se actualizará con los valores del conteo físico.
          </p>

          <div class="confirm-check-box pa-4 rounded-lg mt-6 d-flex align-center">
            <v-checkbox
              v-model="confirmCheck"
              dark
              hide-details
              color="white"
              class="mt-0 pt-0"
            ></v-checkbox>
            <span class="white--text text-caption font-weight-bold text-left">
              Entiendo que los datos del sistema serán modificados.
            </span>
          </div>
        </v-card-text>

        <v-card-actions class="pb-4 px-6 d-flex justify-center">
          <v-btn
            text
            color="grey"
            class="text-none font-weight-black px-6"
            @click="cancelarCierre"
          >
            CANCELAR
          </v-btn>
          <v-btn
            color="white"
            class="black--text text-none font-weight-black rounded-pill px-8 ml-4"
            :disabled="!confirmCheck"
            @click="ejecutarFinalizar"
            :loading="loading"
          >
            CONFIRMAR CIERRE
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import inventarioMixin from "@/mixins/inventario.mixin";
import InventarioAPI from "@/api/inventario";
import SucursalInventarioResumen from "@/views/empresa/sucursales/productos/inventario/components/SucursalInventarioResumen.vue";

export default {
  mixins: [inventarioMixin],
  name: "SucursalProductosInventarioFinalizar",
  components: { SucursalInventarioResumen },
  data() {
    return {
      dialogConfirmacion: false,
      confirmCheck: false,
      loading: false,
      errorMessage: null // Para capturar el error contable
    };
  },
  methods: {
    cancelarCierre() {
      this.dialogConfirmacion = false;
      this.confirmCheck = false;
      this.errorMessage = null;
    },
    async ejecutarFinalizar() {
      this.loading = true;
      this.errorMessage = null;
      try {
        await InventarioAPI.cerrar(this.$route.params.inventarioUuid);
        
        this.$router.push({ name: this.rutaInventario('stock') });
        this.$updateBus.$emit("showSnackBar", {
          show: true, color: "success", text: "Inventario finalizado con éxito", timeout: 3000,
        });
      } catch (err) {
        // Capturamos el error específico del backend
        if (err.response && err.response.data && err.response.data.error) {
          this.errorMessage = err.response.data.error;
        } else if (err.message) {
          this.errorMessage = err.message;
        } else {
          this.errorMessage = "Ocurrió un error inesperado al cerrar el inventario.";
        }
        
        this.$updateBus.$emit("showSnackBar", {
          show: true, color: "error", text: "No se pudo finalizar el inventario", timeout: 4000,
        });
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>

<style scoped>
.bg-dark-refined { background-color: #161616; }
.bg-dark-dialog { background-color: #0f0f0f !important; }
.border-subtle { border: 1px solid #222 !important; }

/* Estilos para la caja de error contable */
.error-box {
  background-color: rgba(244, 67, 54, 0.05);
  border: 1px solid rgba(244, 67, 54, 0.2) !important;
}

.border-red {
  border-left: 4px solid #f44336 !important;
}

.confirm-check-box {
  background-color: #1a1a1a;
  border: 1px solid #333;
}

.v-btn:disabled {
  background-color: #333 !important;
  color: #666 !important;
}
</style>